// Module
var code = "<a ng-show=\"user.profile_attributes[network]\" ng-href=\"{{user.profile_attributes[network]}}\" target=\"_blank\"> <img ng-src=\"{{image}}\" alt=\"{{altText}}\" class=\"fa-img\" ng-show=\"image\"/> <i class=\"fa {{faClass}}\" ng-hide=\"image\"></i> </a> ";
// Exports
var _module_exports = code;;
var path = '/shared/_social_link.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;